import { Suspense } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Header } from '@widgets/header'
import { ParticipantNotices, ParticipantNoticesProvider } from '@widgets/participant-notices'
import { Sidebar, useSidebar } from '@widgets/sidebar'
import { NotificationsUiProvider } from '@entities/notification'
import { usePageTitle } from '@shared/lib/usePageTitle'
import { ErrorBoundary, ErrorFallback } from '@shared/ui/ErrorBoundary'
import { Spinner } from '@shared/ui/Spinner'
import { prefetchRoute } from '../router/routePrefetch'

export function DashboardLayout() {
  const { pathname } = useLocation()
  usePageTitle()
  const sidebar = useSidebar()

  return (
    <NotificationsUiProvider>
      <ParticipantNoticesProvider>
        <div className="flex h-screen overflow-hidden">
          <Sidebar
            isOpen={sidebar.isOpen}
            onClose={sidebar.close}
            isCollapsed={sidebar.isCollapsed}
            onToggleCollapse={sidebar.toggleCollapse}
            onPrefetch={prefetchRoute}
          />

          <div className="flex flex-1 flex-col overflow-hidden">
            <Header onMenuToggle={sidebar.toggle} />

            <main className="flex-1 overflow-y-auto p-4 pb-6 lg:p-6 lg:pb-10">
              {/* Граница стоит внутри шелла, а не поверх него: упавшая страница
                не должна уносить с собой шапку и сайдбар — из них пользователь
                уйдёт на рабочий раздел. `resetKey` по пути снимает ошибку при
                переходе, иначе приложение залипло бы на экране ошибки. */}
              <ErrorBoundary resetKey={pathname} fallback={<ErrorFallback />}>
                <Suspense
                  fallback={
                    <div className="flex h-full items-center justify-center">
                      <Spinner />
                    </div>
                  }
                >
                  <Outlet />
                </Suspense>
              </ErrorBoundary>
            </main>
            <ParticipantNotices />
          </div>
        </div>
      </ParticipantNoticesProvider>
    </NotificationsUiProvider>
  )
}
